<form
  class="reinsurer-form"
  [formGroup]="formularioReasegurador"
  novalidate
  (ngSubmit)="continuar()"
>
  <div class="reinsurer-profile">
    <span>Perfil:</span>
    <strong>Reasegurador</strong>
  </div>

  <section class="reinsurer-alert">
    <span class="reinsurer-alert__icon">
      <mat-icon>verified_user</mat-icon>
    </span>

    <div>
      <h2>Verificamos tu identidad para proteger tu cuenta</h2>
      <p>Tus datos están seguros con nosotros.</p>
    </div>
  </section>

  <section class="reinsurer-section">
    <header class="reinsurer-section__header">
      <mat-icon>lock</mat-icon>
      <h3>Datos de acceso</h3>
    </header>

    <div class="reinsurer-fields-card">
      <div
        class="reinsurer-field reinsurer-field--with-field-error"
        [class.reinsurer-field--invalid]="isInvalid('Cuenta')"
      >
        <label for="reinsurer-account">Clave de Reasegurador*</label>
        <input
          id="reinsurer-account"
          name="atlas-reg-reinsurer-account"
          type="text"
          formControlName="Cuenta"
          placeholder="Ingresa tu clave"
          autocomplete="off"
          autocorrect="off"
          autocapitalize="characters"
          spellcheck="false"
        />

        @if (isInvalid("Cuenta")) {
          <button
            type="button"
            class="reinsurer-field__alert-button reinsurer-field__alert-button--field reinsurer-field__alert-button--error"
            aria-label="Ver detalle de clave de Reasegurador"
            (click)="abrirErrorCampo('Cuenta')"
          >
            <mat-icon>error_outline</mat-icon>
          </button>
        }

        @if (isInvalid("Cuenta")) {
          <small>{{ getError("Cuenta") }}</small>
        }
      </div>

      <div
        class="reinsurer-field reinsurer-field--with-field-error"
        [class.reinsurer-field--invalid]="isInvalid('NIP')"
      >
        <label for="reinsurer-nip">NIP*</label>
        <input
          id="reinsurer-nip"
          name="atlas-reg-reinsurer-nip"
          type="text"
          formControlName="NIP"
          placeholder="Ingresa tu NIP"
          autocomplete="off"
          autocorrect="off"
          autocapitalize="none"
          spellcheck="false"
        />

        @if (isInvalid("NIP")) {
          <button
            type="button"
            class="reinsurer-field__alert-button reinsurer-field__alert-button--field reinsurer-field__alert-button--error"
            aria-label="Ver detalle de NIP"
            (click)="abrirErrorCampo('NIP')"
          >
            <mat-icon>error_outline</mat-icon>
          </button>
        }

        @if (isInvalid("NIP")) {
          <small>{{ getError("NIP") }}</small>
        }
      </div>

      <div
        class="reinsurer-field reinsurer-field--status"
        [class.reinsurer-field--invalid]="isInvalid('Usuario')"
      >
        <label for="reinsurer-user">Usuario*</label>
        <input
          id="reinsurer-user"
          name="atlas-reg-reinsurer-user"
          type="text"
          formControlName="Usuario"
          placeholder="Ingresa tu usuario"
          autocomplete="off"
          autocorrect="off"
          autocapitalize="none"
          spellcheck="false"
          maxlength="8"
        />

        <span class="reinsurer-field__status-action">
          @if (usuarioValido.pending) {
            <mat-icon
              class="reinsurer-field__status-icon reinsurer-field__status-icon--pending"
            >
              sync
            </mat-icon>
          } @else if (usuarioValido.is) {
            <mat-icon
              class="reinsurer-field__status-icon reinsurer-field__status-icon--success"
            >
              check_circle
            </mat-icon>
          } @else if (isInvalid("Usuario")) {
            <button
              type="button"
              class="reinsurer-field__alert-button reinsurer-field__alert-button--error"
              aria-label="Ver error del usuario"
              (click)="abrirErrorCampo('Usuario')"
            >
              <mat-icon>error_outline</mat-icon>
            </button>
          }
        </span>

        @if (isInvalid("Usuario")) {
          <small>{{ getError("Usuario") }}</small>
        }
      </div>

      <div
        class="reinsurer-field reinsurer-field--alias"
        [class.reinsurer-field--invalid]="isInvalid('Alias')"
      >
        <label for="reinsurer-alias">Alias o sobrenombre*</label>
        <input
          id="reinsurer-alias"
          name="atlas-reg-reinsurer-alias"
          type="text"
          formControlName="Alias"
          placeholder="Ingresa tu alias"
          autocomplete="off"
          autocorrect="off"
          spellcheck="false"
        />

        @if (isInvalid("Alias")) {
          <button
            type="button"
            class="reinsurer-field__alert-button reinsurer-field__alert-button--field reinsurer-field__alert-button--error"
            aria-label="Ver detalle del alias"
            (click)="abrirErrorCampo('Alias')"
          >
            <mat-icon>error_outline</mat-icon>
          </button>
        } @else {
          <button
            type="button"
            class="reinsurer-field__alert-button reinsurer-field__alert-button--field reinsurer-field__alert-button--info"
            aria-label="Información sobre el alias"
            (click)="abrirInfoAlias()"
          >
            <mat-icon>info_outline</mat-icon>
          </button>
        }

        @if (isInvalid("Alias")) {
          <small>{{ getError("Alias") }}</small>
        }
      </div>

      <div
        class="reinsurer-field reinsurer-field--password"
        [class.reinsurer-field--invalid]="isInvalid('Password')"
      >
        <label for="reinsurer-password">Contraseña*</label>
        <input
          id="reinsurer-password"
          name="atlas-reg-reinsurer-password"
          [type]="hidePassword ? 'password' : 'text'"
          formControlName="Password"
          placeholder="Ingresa tu contraseña"
          autocomplete="new-password"
          autocorrect="off"
          autocapitalize="none"
          spellcheck="false"
        />

        <span class="reinsurer-field__actions">
          <button
            type="button"
            class="reinsurer-field__icon-button"
            [attr.aria-label]="
              hidePassword ? 'Mostrar contraseña' : 'Ocultar contraseña'
            "
            (click)="hidePassword = !hidePassword"
          >
            <mat-icon>{{
              hidePassword ? "visibility_off" : "visibility"
            }}</mat-icon>
          </button>

          @if (validandoPassword) {
            <mat-icon
              class="reinsurer-field__status-icon reinsurer-field__status-icon--pending"
            >
              sync
            </mat-icon>
          } @else if (mostrarIconoPasswordCorrecto()) {
            <mat-icon
              class="reinsurer-field__status-icon reinsurer-field__status-icon--success"
            >
              check_circle
            </mat-icon>
          } @else if (mostrarIconoPasswordError()) {
            <button
              type="button"
              class="reinsurer-field__alert-button reinsurer-field__alert-button--error"
              aria-label="Ver reglas de contraseña"
              (click)="abrirErroresPassword()"
            >
              <mat-icon>error_outline</mat-icon>
            </button>
          } @else if (isInvalid("Password")) {
            <button
              type="button"
              class="reinsurer-field__alert-button reinsurer-field__alert-button--error"
              aria-label="Ver detalle de contraseña"
              (click)="abrirErrorCampo('Password')"
            >
              <mat-icon>error_outline</mat-icon>
            </button>
          }
        </span>

        @if (isInvalid("Password")) {
          <small>{{ getError("Password") }}</small>
        }
      </div>

      <div
        class="reinsurer-field reinsurer-field--password"
        [class.reinsurer-field--invalid]="isInvalid('ConfirmaPassword')"
      >
        <label for="reinsurer-confirm-password">Confirma contraseña*</label>
        <input
          id="reinsurer-confirm-password"
          name="atlas-reg-reinsurer-confirm-password"
          [type]="hideConfirmPassword ? 'password' : 'text'"
          formControlName="ConfirmaPassword"
          placeholder="Confirma tu contraseña"
          autocomplete="new-password"
          autocorrect="off"
          autocapitalize="none"
          spellcheck="false"
        />

        <span class="reinsurer-field__actions">
          <button
            type="button"
            class="reinsurer-field__icon-button"
            [attr.aria-label]="
              hideConfirmPassword
                ? 'Mostrar confirmación'
                : 'Ocultar confirmación'
            "
            (click)="hideConfirmPassword = !hideConfirmPassword"
          >
            <mat-icon>{{
              hideConfirmPassword ? "visibility_off" : "visibility"
            }}</mat-icon>
          </button>

          @if (mostrarIconoConfirmaPasswordCorrecto()) {
            <mat-icon
              class="reinsurer-field__status-icon reinsurer-field__status-icon--success"
            >
              check_circle
            </mat-icon>
          } @else if (isInvalid("ConfirmaPassword")) {
            <button
              type="button"
              class="reinsurer-field__alert-button reinsurer-field__alert-button--error"
              aria-label="Ver error de confirmación"
              (click)="abrirErrorCampo('ConfirmaPassword')"
            >
              <mat-icon>error_outline</mat-icon>
            </button>
          }
        </span>

        @if (isInvalid("ConfirmaPassword")) {
          <small>{{ getError("ConfirmaPassword") }}</small>
        }
      </div>
    </div>
  </section>

  <section class="reinsurer-section">
    <header class="reinsurer-section__header">
      <mat-icon>verified_user</mat-icon>
      <h3>Verificación de contacto</h3>
    </header>

    <div
      class="reinsurer-contact-card"
      [class.reinsurer-contact-card--email-full]="!dosFaCorreoHabilitado"
      [class.reinsurer-contact-card--phone-full]="!dosFaTelefonoHabilitado"
    >
      <div
        class="reinsurer-field reinsurer-field--with-field-error"
        [class.reinsurer-field--invalid]="isInvalid('Email')"
      >
        <label for="reinsurer-email">Email*</label>
        <input
          id="reinsurer-email"
          name="atlas-reg-reinsurer-email"
          type="text"
          inputmode="email"
          formControlName="Email"
          placeholder="correo@ejemplo.com"
          autocomplete="off"
          autocorrect="off"
          autocapitalize="none"
          spellcheck="false"
          readonly
          (focus)="desbloquearAutofill($event)"
          (blur)="bloquearAutofill($event); verificarCorreoAlPerderFoco()"
          data-lpignore="true"
          data-1p-ignore="true"
          data-form-type="other"
        />

        @if (isInvalid("Email")) {
          <button
            type="button"
            class="reinsurer-field__alert-button reinsurer-field__alert-button--field reinsurer-field__alert-button--error"
            aria-label="Ver detalle del correo electrónico"
            (mousedown)="$event.preventDefault()"
            (click)="abrirErrorCampo('Email')"
          >
            <mat-icon>error_outline</mat-icon>
          </button>
        } @else if (
          formularioReasegurador.controls.Email.value &&
          formularioReasegurador.controls.Email.valid
        ) {
          <span
            class="reinsurer-field__status-action"
            role="status"
            aria-label="Correo electrónico válido"
          >
            <mat-icon
              class="reinsurer-field__status-icon reinsurer-field__status-icon--success"
            >
              check_circle
            </mat-icon>
          </span>
        }

        @if (isInvalid("Email")) {
          <small>{{ getError("Email") }}</small>
        }
      </div>

      <button
        type="button"
        class="reinsurer-verify-button"
        [class.reinsurer-verify-button--hidden]="!dosFaCorreoHabilitado"
        [class.reinsurer-verify-button--ok]="
          !dosFaCorreoHabilitado || validandoCorreo
        "
        [disabled]="
          consultandoNormaCorreo ||
          !dosFaCorreoHabilitado ||
          formularioReasegurador.controls.Email.invalid ||
          procesandoCorreo ||
          validandoCorreo
        "
        (click)="verificarCorreo()"
      >
        <mat-icon
          [class.reinsurer-verify-button__icon--spin]="
            consultandoNormaCorreo || procesandoCorreo
          "
        >
          {{
            !dosFaCorreoHabilitado || validandoCorreo
              ? "check_circle"
              : consultandoNormaCorreo || procesandoCorreo
                ? "sync"
                : "mail"
          }}
        </mat-icon>
        @if (dosFaCorreoHabilitado) {
          <span>
            {{
              consultandoNormaCorreo
                ? "Consultando"
                : validandoCorreo
                  ? "Verificado"
                  : procesandoCorreo
                    ? "Enviando"
                    : "Click para verificar"
            }}
          </span>
        }
      </button>

      <div
        class="reinsurer-field reinsurer-field--phone reinsurer-field--with-field-error"
        [class.reinsurer-field--invalid]="isInvalid('Telefono')"
      >
        <label for="reinsurer-phone">Teléfono celular*</label>

        <div class="reinsurer-phone-control">
          <div class="reinsurer-phone-control__select-wrapper reinsurer-select reinsurer-select--compact">
            <select
              class="reinsurer-phone-control__select reinsurer-select__control"
              aria-label="Código de país"
              [value]="codigoPaisTelefonoSeleccionadoKey"
              (change)="seleccionarCodigoPaisTelefono($event)"
            >
              @for (
                pais of codigosPaisTelefono;
                track getCodigoPaisTelefonoKey(pais)
              ) {
                <option [value]="getCodigoPaisTelefonoKey(pais)">
                  {{ pais.pais }} +{{ pais.codigo }}
                </option>
              }
            </select>
            <mat-icon class="reinsurer-select__chevron">
              keyboard_arrow_down
            </mat-icon>
          </div>

          <input
            id="reinsurer-phone"
            name="atlas-reg-reinsurer-phone"
            type="text"
            inputmode="numeric"
            [value]="telefonoLocal"
            maxlength="10"
            placeholder="10 dígitos"
            autocomplete="off"
            autocorrect="off"
            autocapitalize="none"
            spellcheck="false"
            readonly
            (focus)="desbloquearAutofill($event)"
            (input)="capturarTelefonoLocal($event)"
            (blur)="verificarTelefonoAlPerderFoco()"
            data-lpignore="true"
            data-1p-ignore="true"
            data-form-type="other"
          />
        </div>

        @if (isInvalid("Telefono")) {
          <button
            type="button"
            class="reinsurer-field__alert-button reinsurer-field__alert-button--field reinsurer-field__alert-button--error"
            aria-label="Ver detalle del teléfono celular"
            (mousedown)="$event.preventDefault()"
            (click)="abrirErrorCampo('Telefono')"
          >
            <mat-icon>error_outline</mat-icon>
          </button>
        } @else if (telefonoTieneFormatoCorrecto()) {
          <span
            class="reinsurer-field__status-action"
            role="status"
            aria-label="Teléfono celular válido"
          >
            <mat-icon
              class="reinsurer-field__status-icon reinsurer-field__status-icon--success"
            >
              check_circle
            </mat-icon>
          </span>
        }

        @if (isInvalid("Telefono")) {
          <small>{{ getError("Telefono") }}</small>
        }
      </div>

      <button
        type="button"
        class="reinsurer-verify-button"
        [class.reinsurer-verify-button--hidden]="!dosFaTelefonoHabilitado"
        [class.reinsurer-verify-button--ok]="
          !dosFaTelefonoHabilitado || validandoTelefono
        "
        [disabled]="!telefonoPuedeVerificarse()"
        (click)="verificarTelefono()"
      >
        <mat-icon
          [class.reinsurer-verify-button__icon--spin]="
            consultandoNormaTelefono || procesandoTelefono
          "
        >
          {{
            !dosFaTelefonoHabilitado || validandoTelefono
              ? "check_circle"
              : consultandoNormaTelefono || procesandoTelefono
                ? "sync"
                : "phone_iphone"
          }}
        </mat-icon>
        @if (dosFaTelefonoHabilitado) {
          <span>
            {{
              consultandoNormaTelefono
                ? "Consultando"
                : validandoTelefono
                  ? "Verificado"
                  : procesandoTelefono
                    ? "Enviando"
                    : "Click para verificar"
            }}
          </span>
        }
      </button>
    </div>
  </section>

  <section class="reinsurer-section">
    <header class="reinsurer-section__header">
      <mat-icon>vpn_key</mat-icon>
      <h3>Pregunta de seguridad</h3>
    </header>

    <div class="reinsurer-fields-card">
      <div
        class="reinsurer-field reinsurer-field--select-error"
        [class.reinsurer-field--invalid]="isInvalid('IdPregunta')"
      >
        <label for="reinsurer-question">Pregunta secreta*</label>
        <div class="reinsurer-select">
          <select
            id="reinsurer-question"
            class="reinsurer-select__control"
            formControlName="IdPregunta"
          >
            <option [ngValue]="null">Selecciona una pregunta</option>
            @for (pregunta of catPreguntas; track pregunta.Value) {
              <option [ngValue]="pregunta.Value">{{ pregunta.Text }}</option>
            }
          </select>
          <mat-icon class="reinsurer-select__chevron">
            keyboard_arrow_down
          </mat-icon>
        </div>

        @if (isInvalid("IdPregunta")) {
          <button
            type="button"
            class="reinsurer-field__alert-button reinsurer-field__alert-button--field reinsurer-field__alert-button--error"
            aria-label="Ver detalle de pregunta secreta"
            (click)="abrirErrorCampo('IdPregunta')"
          >
            <mat-icon>error_outline</mat-icon>
          </button>
        }

        @if (isInvalid("IdPregunta")) {
          <small>{{ getError("IdPregunta") }}</small>
        }
      </div>

      <div
        class="reinsurer-field reinsurer-field--with-field-error"
        [class.reinsurer-field--invalid]="isInvalid('Respuesta')"
      >
        <label for="reinsurer-answer">Respuesta*</label>
        <input
          id="reinsurer-answer"
          name="atlas-reg-reinsurer-answer"
          type="text"
          formControlName="Respuesta"
          placeholder="Escribe tu respuesta"
          autocomplete="off"
          autocorrect="off"
          spellcheck="false"
        />

        @if (isInvalid("Respuesta")) {
          <button
            type="button"
            class="reinsurer-field__alert-button reinsurer-field__alert-button--field reinsurer-field__alert-button--error"
            aria-label="Ver detalle de respuesta"
            (click)="abrirErrorCampo('Respuesta')"
          >
            <mat-icon>error_outline</mat-icon>
          </button>
        }

        @if (isInvalid("Respuesta")) {
          <small>{{ getError("Respuesta") }}</small>
        }
      </div>
    </div>
  </section>

  <section class="reinsurer-section">
    <header class="reinsurer-section__header">
      <mat-icon>business</mat-icon>
      <h3>Datos del reasegurador</h3>
    </header>

    <div class="reinsurer-fields-card">
      <div
        class="reinsurer-field reinsurer-field--select-error"
        [class.reinsurer-field--invalid]="isInvalid('Nacionalidad')"
      >
        <label for="reinsurer-nationality">Nacionalidad*</label>
        <div class="reinsurer-select">
          <select
            id="reinsurer-nationality"
            class="reinsurer-select__control"
            formControlName="Nacionalidad"
          >
            <option [ngValue]="null">Selecciona una nacionalidad</option>
            <option value="1">Mexicano</option>
            <option value="2">Extranjero</option>
          </select>
          <mat-icon class="reinsurer-select__chevron">
            keyboard_arrow_down
          </mat-icon>
        </div>

        @if (isInvalid("Nacionalidad")) {
          <button
            type="button"
            class="reinsurer-field__alert-button reinsurer-field__alert-button--field reinsurer-field__alert-button--error"
            aria-label="Ver detalle de nacionalidad"
            (click)="abrirErrorCampo('Nacionalidad')"
          >
            <mat-icon>error_outline</mat-icon>
          </button>
        }

        @if (isInvalid("Nacionalidad")) {
          <small>{{ getError("Nacionalidad") }}</small>
        }
      </div>

      <div
        class="reinsurer-field reinsurer-field--with-field-error"
        [class.reinsurer-field--disabled]="
          !formularioReasegurador.controls.Nacionalidad.value
        "
        [class.reinsurer-field--invalid]="isInvalid('RFC')"
      >
        <label for="reinsurer-tax-id">{{ tipoIdentificadorFiscal }}*</label>
        <input
          id="reinsurer-tax-id"
          name="atlas-reg-reinsurer-tax-id"
          type="text"
          formControlName="RFC"
          [placeholder]="placeholderIdentificadorFiscal"
          [maxlength]="longitudIdentificadorFiscal"
          autocomplete="off"
          autocorrect="off"
          autocapitalize="characters"
          spellcheck="false"
          (input)="capturarIdentificadorFiscal($event)"
        />

        @if (isInvalid("RFC")) {
          <button
            type="button"
            class="reinsurer-field__alert-button reinsurer-field__alert-button--field reinsurer-field__alert-button--error"
            [attr.aria-label]="'Ver detalle de ' + tipoIdentificadorFiscal"
            (click)="abrirErrorCampo('RFC')"
          >
            <mat-icon>error_outline</mat-icon>
          </button>
        }

        @if (isInvalid("RFC")) {
          <small>{{ getError("RFC") }}</small>
        }
      </div>

      <div
        class="reinsurer-field reinsurer-field--full reinsurer-field--with-field-error"
        [class.reinsurer-field--invalid]="isInvalid('RazonSocial')"
      >
        <label for="reinsurer-business-name">Razón social*</label>
        <input
          id="reinsurer-business-name"
          name="atlas-reg-reinsurer-business-name"
          type="text"
          formControlName="RazonSocial"
          placeholder="Ingresa la razón social"
          autocomplete="organization"
          autocorrect="off"
          spellcheck="false"
        />

        @if (isInvalid("RazonSocial")) {
          <button
            type="button"
            class="reinsurer-field__alert-button reinsurer-field__alert-button--field reinsurer-field__alert-button--error"
            aria-label="Ver detalle de razón social"
            (click)="abrirErrorCampo('RazonSocial')"
          >
            <mat-icon>error_outline</mat-icon>
          </button>
        }

        @if (isInvalid("RazonSocial")) {
          <small>{{ getError("RazonSocial") }}</small>
        }
      </div>
    </div>
  </section>

  <div class="reinsurer-actions">
    <button
      type="button"
      class="reinsurer-action reinsurer-action--secondary"
      [disabled]="loadingRegistro"
      (click)="regresar()"
    >
      Regresar
    </button>

    <button
      type="submit"
      class="reinsurer-action reinsurer-action--primary"
      [disabled]="loadingRegistro"
    >
      @if (loadingRegistro) {
        <mat-icon class="reinsurer-action__spinner">sync</mat-icon>
        <span>Registrando</span>
      } @else {
        <span>Continuar</span>
      }
    </button>
  </div>
</form>
